module.exports = __webpack_public_path__ + "img/b2.0f85e0b7.png";